import {Component, Inject, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {Asset} from '@app/asset';

@Component({
    selector: 'frog-delete-asset-dialog',
    templateUrl: './delete-asset-dialog.component.html',
    styleUrls: ['./delete-asset-dialog.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatButton, MatDialogClose, MatDialogActions],
})
export class DeleteAssetDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DeleteAssetDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Asset[] | string[],
    ) {}

    ngOnInit(): void {}
}
